import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const IssueReport = React.lazy(() => import("./issue"));
const AttendanceReport = React.lazy(() => import("./attendance"));
const LeaveReport = React.lazy(() => import("./leave"));
const RoomBookingReport = React.lazy(() => import("./roomBooking"));
const FeedbackReport = React.lazy(() => import("./feedback"));
const BirthdayReport = React.lazy(() => import("./birthday"));

export const ReportConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.MANAGER,
        ],
        path: "/reports/issue-report",
        element: <IssueReport />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.MEMBER,
        ],
        path: "/reports/attendance-report",
        element: <AttendanceReport />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
        ],
        path: "/reports/leave-report",
        element: <LeaveReport />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/reports/room-booking-report",
        element: <RoomBookingReport />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/reports/feedback-report",
        element: <FeedbackReport />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
        path: "/reports/birthday-report",
        element: <BirthdayReport />,
    },
];
